import { Partner } from "@api";
import { OnboardingAddCardTemplate } from "./template";
import { useOnboardingAddCardPage } from "./logic";
import { Invoice } from "../../../types";

export type OnboardingAddCardTemplateProps = {
  partner: Partner,
  modalIsOpen: boolean;
  closeModal: () => void;
  onPressAddCard: () => void;
  selectedCardIndex: number;
  //onPressDownloadInvoice: () => void;
  cardDataList: any;
  //invoices: [Invoice] | null;
  handleSubmit: () => void;
  handleCardInputChange: () => void;
  succeeded: boolean;
  processing: boolean;
  disabled: boolean;
  error: any;
  isAddressSubmitted: boolean;
  handleUpgradeClick: () => void;
  handleSendEmailClick: () => void;
  planAmount: number;
  onReturnPressed: () => void;
  onContinuePressed: () => void;
}

export const OnboardingAddCardPage = (): JSX.Element => {
  const logic = useOnboardingAddCardPage();

  return (
    <OnboardingAddCardTemplate {...logic} />
  );
};
